import { render, staticRenderFns } from "./SubCategoriaForm.vue?vue&type=template&id=a6b12f94"
import script from "./SubCategoriaForm.vue?vue&type=script&lang=js"
export * from "./SubCategoriaForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports